import * as types from './gtfs_reducer';

export function set(new_state, state) {
  return {
    type: types.GTFS_STATE_ASSIGN_STATE,
    payload: new_state,
  };
}
